import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core, Decorative } from "@faire/design-tokens";
import { mobileTypographyDeviation } from "@faire/retailer-visitor-shared/lib/typographyDeviation";
import { Insider } from "@faire/web--source/slate/icons/InsiderIcon";
import { Row } from "@faire/web--source/slate/Layout";
import { Typography } from "@faire/web--source/slate/Typography";
import React from "react";
import styled from "styled-components";
export var InsiderLabelWithIcon = function(param) {
    var description = param.description, minWidth = param.minWidth, className = param.className, testId = param.testId, prefix = param.prefix, reverseIcon = param.reverseIcon, shortenedLabel = param.shortenedLabel, largerFontOnMobile = param.largerFontOnMobile, large = param.large, light = param.light;
    var labelRef = React.useRef(null);
    var _React_useState = _sliced_to_array(React.useState(false), 2), showDescription = _React_useState[0], setShowDescription = _React_useState[1];
    // Show description only if there's enough space to render it without a line break
    React.useLayoutEffect(function() {
        var _labelRef_current, _labelRef_current1;
        setShowDescription(minWidth && description && (labelRef === null || labelRef === void 0 ? void 0 : (_labelRef_current = labelRef.current) === null || _labelRef_current === void 0 ? void 0 : _labelRef_current.clientWidth) ? (labelRef === null || labelRef === void 0 ? void 0 : (_labelRef_current1 = labelRef.current) === null || _labelRef_current1 === void 0 ? void 0 : _labelRef_current1.clientWidth) >= minWidth : !!description);
    }, [
        description,
        minWidth
    ]);
    return /*#__PURE__*/ _jsx("div", {
        ref: labelRef,
        className: className,
        "data-test-id": testId,
        children: /*#__PURE__*/ _jsxs(Row, {
            align: "center",
            style: {
                maxWidth: "100%"
            },
            gap: large ? "1x" : 4,
            children: [
                reverseIcon ? /*#__PURE__*/ _jsx(Icon, {
                    large: large,
                    light: light
                }) : null,
                /*#__PURE__*/ _jsxs(StyledTypography, {
                    color: light ? Core.text.inverse : Decorative.shade.teal,
                    truncate: true,
                    $largerFont: largerFontOnMobile,
                    variant: "paragraphSansMedium",
                    children: [
                        prefix ? "".concat(prefix, " ") : "",
                        !showDescription && shortenedLabel ? shortenedLabel : "Insider",
                        showDescription && description ? " ".concat(description) : ""
                    ]
                }),
                !reverseIcon ? /*#__PURE__*/ _jsx(Icon, {
                    large: large,
                    light: light
                }) : null
            ]
        })
    });
};
var Icon = function(param) {
    var large = param.large, light = param.light;
    return /*#__PURE__*/ _jsx(StyledInsider, {
        small: !large,
        color: light ? Core.icon.inverse : Decorative.icon.teal,
        fill: large ? "transparent" : Decorative.icon.teal,
        fontSize: large ? "24px" : "16px"
    });
};
var StyledInsider = styled(Insider).withConfig({
    componentId: "sc-30cbf64d-0"
})([
    "position:relative;top:1.5px;"
]);
var StyledTypography = styled(Typography).withConfig({
    componentId: "sc-30cbf64d-1"
})([
    "",
    ""
], function(props) {
    return props.$largerFont ? mobileTypographyDeviation : "";
});
